<template>
  <div class="information">
    <div class="body">
      <div class="title">
        <slot name="information-title"></slot>
      </div>
      <div class="description" >
        <slot name="information-description"></slot>
      </div>
    </div>
    <div v-if="imgName" class="image-container">
      <img :src="require(`@/assets/onboarding/${imgName}`)" />
    </div>
    <lottie-player v-if="animationName" :src="JSON.stringify(require(`@/assets/animations/${animationName}`))" :autoplay="true"/>
    <div class="footer">
      <single-click-button :title="buttonTitle" :action="buttonAction" :size="'small'"/>
      <single-click-button v-if="secondaryButtonTitle"
                           :title="secondaryButtonTitle"
                           :action="secondaryButtonAction"
                           variant="flat"/>
    </div>
  </div>
</template>

<script>

import SingleClickButton from '../../../../../../base-components/SingleClickButton';

export default {
  name: 'Information',
  components: {
    SingleClickButton,
  },
  props: {
    buttonTitle: {
      type: String,
      required: true,
    },
    animationName: {
      type: String,
      required: false,
    },
    imgName: {
      type: String,
      required: false,
    },
    buttonAction: {
      type: Function,
      required: true,
    },
    secondaryButtonTitle: {
      type: String,
      required: false,
    },
    secondaryButtonAction: {
      type: Function,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .information {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .body {
      color: $riseup_black;
      position: relative;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      padding: 26px;
      padding-bottom: 0px;

      .title {
        font-size: 24px;
        font-weight: bold;
        line-height: 32px;
        padding: 10px 0px;
        white-space: pre-line;
      }

      .description {
        padding: 16px 0px;
        font-size: 18px;
        line-height: 1.3;
        flex-grow: 1;
      }

      .bold {
        font-weight: bold;
      }

    }

    .image-container{
      display: flex;
      justify-content: center;
    }

    lottie-player {
      height: auto;
    }

    .footer {
      position: sticky;
      bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: $riseup_white;
      padding: 30px;

      .riseup-button {
        width: 100%;
        height: 75px;
      }
    }
  }

</style>
